import { IModalDescription } from '@cp/shared/modal';
import type { OtpModalLayoutProps } from '../ui/otpModalLayout';
import type { LoginModalProps } from '../ui/loginModalLayout';
import type { EmailModalLayoutProps } from '../ui/emailOTPModalLayout';
import type { AuthVariantsModalLayoutProps } from '../ui/authVariantsModalLayout';
import type { LogoutModalProps } from '../ui/logoutModal';

export const LOGIN_MODAL: IModalDescription<LoginModalProps> = {
  nss: 'login',
  loader: () => import('../ui/loginModalLayout').then((module) => module.LoginModalLayout),
};

export const SMS_OTP_MODAL: IModalDescription<OtpModalLayoutProps> = {
  nss: 'sms-otp',
  loader: () => import('../ui/otpModalLayout').then((module) => module.OtpModalLayout),
};

export const EMAIL_OTP_MODAL: IModalDescription<EmailModalLayoutProps> = {
  nss: 'email-otp',
  loader: () => import('../ui/emailOTPModalLayout').then((module) => module.EmailOtpModalLayout),
};

export const LOGIN_VARIANTS_MODAL: IModalDescription<AuthVariantsModalLayoutProps> = {
  nss: 'login-variants',
  loader: () => import('../ui/authVariantsModalLayout').then((m) => m.AuthVariantsModalLayout),
};

export const LOGOUT_MODAL: IModalDescription<LogoutModalProps> = {
  nss: 'auth/logout',
  loader: () => import('../ui/logoutModal').then((m) => m.LogoutModal),
};
